// extracted by mini-css-extract-plugin
module.exports = {"root":"InquiryBroadcastErrors_root__fvwun"};